module.exports = __webpack_public_path__ + "static/media/uv1.a8677034.jpg";